import React from 'react';
import {ToastContainer, toast, Slide} from 'react-toastify';
import {IconButton} from "@material-tailwind/react";
import 'react-toastify/dist/ReactToastify.css';
import {Close} from "@mui/icons-material";
import CustomButton from "./CustomButton";
import {useTranslation} from "react-i18next";
import {ToastType} from "../../services/types/toast";

export const showToast = (message: string, type?: ToastType, event?: any, loading?: boolean, eventBeforeClosing?: any) => {
    switch (type) {
        case 'error' :
            toast(<CustomToast {...{message, type, event, eventBeforeClosing}} />, {toastId: 'error'});
            break;
        case 'info' :
            toast(<CustomToast {...{message, type, event, eventBeforeClosing}} />, {toastId: 'info'});
            break;
        case 'info-success' :
            toast(<CustomToast {...{message, type, event, loading, eventBeforeClosing}} />, {toastId: 'info-success'});
            break;
        case 'warning' :
            toast(<CustomToast {...{message, type, event, loading, eventBeforeClosing}} />, {toastId: 'warning'});
            break;
        case 'warning-success' :
            toast(<CustomToast {...{message, type, event, loading, eventBeforeClosing}} />, {toastId: 'warning-success'});
            break;
        case 'warning-info' :
            toast(<CustomToast {...{message, type, event, loading, eventBeforeClosing}} />, {toastId: 'warning-info'});
            break;
        default :
            toast(<CustomToast {...{message, type, event, eventBeforeClosing}} />, {toastId: 'success'});
            break;
    }
};

const CustomToast: React.FC<{ message: string, type?: string, event?: any, loading?: boolean, eventBeforeClosing?: any }> = ({message, type, event, loading, eventBeforeClosing}) => {
    const { t } = useTranslation("global") as { t: (key: string) => string };
    return(
        <div className="custom-toast-container-overlay">
            <div
                className={'grid text-center min-w-[400px] max-w-[400px] sm:min-w-[471px] sm:max-w-[471px] bg-[#FFF] rounded-[12px] border-[1px] border-gray-400 py-[26px] px-[10px]'} style={{minHeight: '335px'}}>
                <div className={'w-full text-right'}>
                    <IconButton placeholder="icon-button"  variant="text" color="blue-gray" onClick={() => {
                        if (eventBeforeClosing) { eventBeforeClosing() }
                        toast.dismiss(type)
                    }}>
                        <Close className="w-5 text-black"/>
                    </IconButton>
                </div>
                <div className={'w-full flex justify-center'}>
                    {type === 'error' ?
                        <span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="71" height="71" viewBox="0 0 71 71" fill="none">
                      <path
                          d="M35.5001 5.91669C19.1405 5.91669 5.91675 19.1404 5.91675 35.5C5.91675 51.8596 19.1405 65.0834 35.5001 65.0834C51.8597 65.0834 65.0834 51.8596 65.0834 35.5C65.0834 19.1404 51.8597 5.91669 35.5001 5.91669ZM35.5001 59.1667C22.4538 59.1667 11.8334 48.5463 11.8334 35.5C11.8334 22.4538 22.4538 11.8334 35.5001 11.8334C48.5463 11.8334 59.1667 22.4538 59.1667 35.5C59.1667 48.5463 48.5463 59.1667 35.5001 59.1667ZM46.1205 20.7084L35.5001 31.3288L24.8797 20.7084L20.7084 24.8796L31.3288 35.5L20.7084 46.1204L24.8797 50.2917L35.5001 39.6713L46.1205 50.2917L50.2917 46.1204L39.6713 35.5L50.2917 24.8796L46.1205 20.7084Z"
                          fill="#FF0000"/>
                    </svg>
                </span> :
                        (type === 'warning' || type === 'warning-success' || type === 'warning-info') ?
                            <span>
                        <svg width="71" height="71" viewBox="0 0 71 71" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M35.4999 19.1996L57.7762 57.6875H13.2237L35.4999 19.1996ZM35.4999 7.39583L2.95825 63.6042H68.0416L35.4999 7.39583Z"
                                fill="#FBE200"/>
                            <path d="M38.4582 48.8125H32.5416V54.7292H38.4582V48.8125Z" fill="#FBE200"/>
                            <path d="M38.4582 31.0625H32.5416V45.8542H38.4582V31.0625Z" fill="#FBE200"/>
                        </svg>
                    </span> :
                            type === 'success' ?
                                <span>
                            <svg width="71" height="71" viewBox="0 0 71 71" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M49.0788 22.4241L29.5834 41.9195L18.963 31.3287L14.7917 35.5L29.5834 50.2916L53.2501 26.625L49.0788 22.4241ZM35.5001 5.91663C19.1701 5.91663 5.91675 19.17 5.91675 35.5C5.91675 51.83 19.1701 65.0833 35.5001 65.0833C51.8301 65.0833 65.0834 51.83 65.0834 35.5C65.0834 19.17 51.8301 5.91663 35.5001 5.91663ZM35.5001 59.1666C22.4242 59.1666 11.8334 48.5758 11.8334 35.5C11.8334 22.4241 22.4242 11.8333 35.5001 11.8333C48.5759 11.8333 59.1668 22.4241 59.1668 35.5C59.1668 48.5758 48.5759 59.1666 35.5001 59.1666Z"
                                    fill="#4CAF50"/>
                            </svg>
                        </span> :
                                <span>
                            <svg width="71" height="71" viewBox="0 0 71 71" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M32.5417 20.7083H38.4584V26.625H32.5417V20.7083ZM32.5417 32.5416H38.4584V50.2916H32.5417V32.5416ZM35.5001 5.91663C19.1701 5.91663 5.91675 19.17 5.91675 35.5C5.91675 51.83 19.1701 65.0833 35.5001 65.0833C51.8301 65.0833 65.0834 51.83 65.0834 35.5C65.0834 19.17 51.8301 5.91663 35.5001 5.91663ZM35.5001 59.1666C22.4538 59.1666 11.8334 48.5462 11.8334 35.5C11.8334 22.4537 22.4538 11.8333 35.5001 11.8333C48.5463 11.8333 59.1668 22.4537 59.1668 35.5C59.1668 48.5462 48.5463 59.1666 35.5001 59.1666Z"
                                    fill="#1976D2"/>
                            </svg>
                        </span>}
                </div>
                <span
                    className={'note'}>{type === 'error' ? t('error-toast') : (type === 'warning' || type === 'warning-success') ? t('warning-toast') : type === 'success' ? t('success-toast') : t('important-toast')}</span>
                <div className={'text mt-[20px]'}>{message}</div>
                <div className={'w-full flex justify-center gap-[26px]'}>
                    {
                        type === 'warning' ?
                            [<CustomButton
                                textSize={'17px'}
                                text={t('not')}
                                color="gray"
                                onClick={() => {
                                    if (eventBeforeClosing) { eventBeforeClosing() }
                                    toast.dismiss(type)
                                }}
                                className="bg-[#E9E8E8] text-center min-w-[75px] max-w-[75px] mt-[30px]"
                            />,
                                <CustomButton
                                    textSize={'17px'}
                                    text={t('yes')}
                                    color="red"
                                    onClick={() => {
                                        event()
                                        toast.dismiss(type)
                                    }}
                                    className="bg-danger text-center min-w-[75px] max-w-[75px] mt-[30px]"
                                    loading={loading}
                                />
                            ] :
                            type === 'warning-success' ?
                                [<CustomButton
                                    textSize={'17px'}
                                    text={t('not')}
                                    color="gray"
                                    onClick={() => {
                                        if (eventBeforeClosing) { eventBeforeClosing() }
                                        toast.dismiss(type)
                                    }}
                                    className="bg-[#E9E8E8] text-center min-w-[75px] max-w-[75px] mt-[30px]"
                                />,
                                    <CustomButton
                                        textSize={'17px'}
                                        text={t('yes')}
                                        color="green"
                                        onClick={() => {
                                            event()
                                            toast.dismiss(type)
                                        }}
                                        className="bg-success text-center min-w-[75px] max-w-[75px] mt-[30px]"
                                        loading={loading}
                                    />] :
                                type === 'info-success' ?
                                    [<CustomButton
                                        textSize={'17px'}
                                        text={t('not')}
                                        color="gray"
                                        onClick={() => {
                                            if (eventBeforeClosing) { eventBeforeClosing() }
                                            toast.dismiss(type)
                                        }}
                                        className="bg-[#E9E8E8] text-center min-w-[75px] max-w-[75px] mt-[30px]"
                                    />,
                                        <CustomButton
                                            textSize={'17px'}
                                            text={t('yes')}
                                            color="green"
                                            onClick={() => {
                                                event()
                                                toast.dismiss(type)
                                            }}
                                            className="bg-success text-center min-w-[75px] max-w-[75px] mt-[30px]"
                                            loading={loading}
                                        />] :
                                <CustomButton
                                    textSize={'14px'}
                                    text={'CERRAR'}
                                    color="gray"
                                    onClick={() => {
                                        if (eventBeforeClosing) { eventBeforeClosing() }
                                        toast.dismiss(type)
                                    }}
                                    className="bg-[#E9E8E8] max-w-[110px] max-w-[110px] mt-[30px]"
                                />
                    }
                </div>
            </div>
        </div>
    );
}

const CustomToastContainer = () => {
    return (
        <ToastContainer
            position="top-left"
            autoClose={3600000}
            hideProgressBar
            closeButton={false}
            pauseOnHover={false}
            draggable={false}
            closeOnClick={false}
            toastClassName="custom-toast"
            transition={Slide}
            style={{
                zIndex: 10000,
                width: '100%',
                height: '100vh'
            }}
            limit={1}
        />
    );
};

export default CustomToastContainer;
